import {inject, injectable} from 'inversify'
import {SingletonService} from '@/common/dependency.configs'
import type RestResponse from '@/common/data/RestResponse'
import HttpHandler from '@/common/services/connect/HttpHandler'

export interface ActiveUser {
  lastName: string
  firstName: string
  email: string
  institutionId: string
  jhid: string
  login: string // todo(mikol): this is backwards compatible, for legacy users this will be their username, for new users it should be the banno email.
}

@SingletonService
@injectable()
export class ActiveUserService {

  constructor(
    @inject(HttpHandler) private httpHandler: HttpHandler,
  ) {}

  getActiveUser(): Promise<RestResponse<ActiveUser>> {
    return this.httpHandler.get('{{launchpad}}/active/user', {cache: true})
  }

}
